<template>
  <div class="settings-section">
    <div class="section-header">
      <h2 class="section-title">Default Margin Target</h2>
      <span class="required-badge">REQUIRED</span>
    </div>

    <div class="form-group">
      <label class="form-label">Minimum Margin Target</label>
      <div class="margin-input-wrapper">
        <input 
          type="number" 
          step="0.1" 
          min="0" 
          max="100"
          :value="settings.defaultMarginPercentage"
          @input="onMarginChange"
          class="margin-input">
        <span class="percent-symbol">%</span>
      </div>
      <p class="form-hint">Applied to all products unless overridden</p>
      <p class="form-description">
        This is the minimum profit margin you want to maintain. Floor prices are calculated to protect this margin.
      </p>
    </div>

    <div class="form-group">
      <div class="toggle-wrapper">
        <label class="toggle-label">Alert when price approaches floor</label>
        <div class="ui toggle checkbox" :class="{ checked: settings.floorPriceAlertEnabled }">
          <input 
            type="checkbox" 
            :checked="settings.floorPriceAlertEnabled"
            @change="onToggleChange">
          <label></label>
        </div>
      </div>
      <p class="form-hint">Get notified when any product's margin drops below your target</p>
    </div>

    <div class="info-box">
      <i class="info circle icon"></i>
      <div class="info-content">
        <strong>How floor price is calculated:</strong>
        <div class="formula">
          {{ formulaDescription }}
        </div>
        <div class="example">
          Example: ({{ formatPrice(formulaExample.landed_cost) }} + {{ formatPrice(formulaExample.amazon_fees) }}) ÷ (1-{{ (formulaExample.margin_percentage / 100).toFixed(2) }}) = {{ formatPrice(formulaExample.result) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DefaultMarginTargetSection',
  props: {
    settings: {
      type: Object,
      required: true
    },
    formulaDescription: {
      type: String,
      default: 'Floor Price = (Landed Cost + Amazon Fees) ÷ (1 - Margin%)'
    },
    formulaExample: {
      type: Object,
      default: function () {
        return {
          landed_cost: 10.50,
          amazon_fees: 7.52,
          margin_percentage: 20.0,
          result: 22.53
        }
      }
    }
  },
  mounted: function () {
    this.initializeToggle()
  },
  methods: {
    initializeToggle: function () {
      this.$nextTick(() => {
        if (typeof $ !== 'undefined') {
          $('.ui.checkbox').checkbox()
        }
      })
    },
    onMarginChange: function (event) {
      let value = parseFloat(event.target.value) || 0
      if (value < 0) value = 0
      if (value > 100) value = 100
      this.$emit('margin-change', value)
    },
    onToggleChange: function (event) {
      const checked = event.target.checked
      this.$nextTick(() => {
        if (typeof $ !== 'undefined') {
          $('.ui.checkbox').checkbox('set checked', checked)
        }
      })
      this.$emit('toggle-change', checked)
    },
    formatPrice: function (price) {
      if (price === null || price === undefined || isNaN(price)) return '$0.00'
      return '$' + parseFloat(price).toFixed(2)
    }
  }
}
</script>

<style scoped>
@import './styles/DefaultMarginTargetSection.css';
</style>




// WEBPACK FOOTER //
// DefaultMarginTargetSection.vue?d596d36c